import { Button, CircularProgress, Stack } from '@mui/material';
// import { useServiceGroupQuery } from "@tms/services/tms-location";
import { useFormik } from 'formik';
import SelectInput from '../components/Select';
import TextInput from '../components/TextInput';
import { FIELD_SIZE, Section, StickyActions } from '../components/Section';
// import {
//   useCurrentUserDetailsQuery,
//   useGetJobDetailQuery,
//   useUpdateJobDetailMutation
// } from "@tms/services/tms-user";
// import { useServiceSubGroupQuery } from "@tms/services/tms-location";

import {
  BatchOptions,
  jobDetailsInitialValue,
  JobDetailsSchemaValidation,
  modeOfEntry,
  traineeType
} from './Schema';
import React from 'react';
import {
  useServiceGroupQuery,
  useServiceSubGroupQuery
} from 'redux/reducers/user/dashboard/tms-user-location';
import { useCurrentUserDetailsQuery } from 'redux/reducers/administrator';
import {
  useGetJobDetailQuery,
  useUpdateJobDetailMutation
} from 'redux/reducers/user/dashboard/tms-user';
import { toast } from 'react-toastify';

function JobDetail({
  activeStep,
  setActiveStep
}: {
  activeStep: number;
  setActiveStep: (step: number) => void;
}) {
  const { data: serviceGroups, isLoading: serviceGroupLoading } = useServiceGroupQuery();

  const [serviceGroupId, setServiceGroupId] = React.useState('');

  //   const serviceGroupArray = serviceGroups?.map((serviceGroup) => {
  //     return {
  //       label: serviceGroup.name,
  //       value: serviceGroup.id.toString()
  //     };
  //   });
  const serviceGroupArray = Array.isArray(serviceGroups)
    ? serviceGroups.map((serviceGroup) => ({
        label: serviceGroup.name,
        value: serviceGroup.id?.toString() ?? ''
      }))
    : [];

  const {
    data: serviceSubGroup,
    isLoading: isServiceSubGroupLoading,
    isSuccess: subGroupSuccess
  } = useServiceSubGroupQuery(serviceGroupId ?? '');

  const ServiceSub = serviceSubGroup?.data[0]?.service_sub_group?.map((service: any) => {
    return {
      label: service.name,
      value: service.id
    };
  });

  const { data: CurrentUser, isLoading: isCurrentUserLoading } = useCurrentUserDetailsQuery();
  const TraineeId = CurrentUser?.id;

  const {
    data: jobDetail,
    isLoading: isJobDetailLoading,
    isSuccess,
    isFetching
  } = useGetJobDetailQuery(TraineeId ?? '', (data) => {
    formik.resetForm({
      values: {
        ...jobDetailsInitialValue,
        service_group: data?.data?.service_group_data?.id.toString() ?? '',
        service_sub_group: data?.data?.service_sub_group_data?.id ?? '',
        mode_of_entry: data?.data?.mode_of_entry ?? '',
        psc_merit_number: data?.data?.psc_merit_number ?? null,
        batch: data?.data?.batch ?? '',
        trainee_type: data?.data?.trainee_type ?? ''
      }
    });
  });

  const { mutateAsync: updateJobDetail, isLoading: isJobDetailUpdating } =
    useUpdateJobDetailMutation(TraineeId ?? '');

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema: JobDetailsSchemaValidation,
    initialValues: jobDetailsInitialValue,
    onSubmit: async (values) => {
      const { service_sub_group, ...sendValue } = values;
      try {
        if (service_sub_group === '') {
          await updateJobDetail(sendValue);
          // setActiveStep(++activeStep);
          toast.success('Updated Successfully');
        } else {
          updateJobDetail(values);
          // setActiveStep(++activeStep);
          toast.success('Updated Successfully');
        }
      } catch (err: any) {
        toast.error(err?.response?.data?.message ?? '');
      }
    }
  });

  React.useEffect(() => {
    setServiceGroupId(jobDetail?.data?.service_group_data?.id);
  }, [isSuccess]);

  const isSaving = isJobDetailUpdating || formik.isSubmitting;

  if (isCurrentUserLoading || isJobDetailLoading) {
    return (
      <Stack alignItems="center" justifyContent="center" sx={{ minHeight: 320 }}>
        <CircularProgress />
      </Stack>
    );
  }

  return (
    <form onSubmit={formik.handleSubmit}>
      <Section title="Service" description="The service group you belong to.">
        <SelectInput
          {...FIELD_SIZE}
          label="Service Group"
          name="service_group"
          options={serviceGroupArray || []}
          value={formik.values.service_group}
          onChange={(e) => {
            formik.setFieldValue('service_sub_group', '');
            setServiceGroupId(e.target.value);
            formik.handleChange(e);
          }}
          error={
            formik.errors.service_group
              ? {
                  message: formik.errors.service_group
                }
              : undefined
          }
          required
        />
        <SelectInput
          {...FIELD_SIZE}
          label="Service Sub Group"
          name="service_sub_group"
          options={ServiceSub || []}
          value={formik.values.service_sub_group}
          onChange={(e) => {
            formik.handleChange(e);
          }}
          error={
            formik.errors.service_sub_group
              ? {
                  message: formik.errors.service_sub_group
                }
              : undefined
          }
          required
        />
      </Section>

      <Section title="Appointment" description="How and when you joined the service.">
        <SelectInput
          {...FIELD_SIZE}
          label="Mode of Entry"
          name="mode_of_entry"
          options={modeOfEntry || []}
          value={formik.values.mode_of_entry}
          onChange={(e) => {
            formik.handleChange(e);
          }}
          error={
            formik.errors.mode_of_entry
              ? {
                  message: formik.errors.mode_of_entry
                }
              : undefined
          }
          required
        />

        <TextInput
          {...FIELD_SIZE}
          label="PSC Merit Number"
          name="psc_merit_number"
          type="text"
          onChange={formik.handleChange}
          value={formik.values.psc_merit_number}
          onBlur={formik.handleBlur}
          formik={formik}
          // required
        />
        <SelectInput
          {...FIELD_SIZE}
          label="Batch"
          name="batch"
          options={BatchOptions || []}
          value={formik.values.batch}
          onChange={(e) => {
            formik.handleChange(e);
          }}
          error={
            formik.errors.batch
              ? {
                  message: formik.errors.batch
                }
              : undefined
          }
          // required
        />
        <SelectInput
          {...FIELD_SIZE}
          label="Trainee Type"
          name="trainee_type"
          options={traineeType || []}
          value={formik.values.trainee_type}
          onChange={(e) => {
            formik.handleChange(e);
          }}
          error={
            formik.errors.trainee_type
              ? {
                  message: formik.errors.trainee_type
                }
              : undefined
          }
          required
        />
      </Section>

      <StickyActions>
        {activeStep > 1 && (
          <Button
            variant="outlined"
            color="inherit"
            onClick={() => setActiveStep(--activeStep)}
            sx={{ width: { xs: '100%', sm: 'auto' } }}
          >
            Previous Step
          </Button>
        )}

        <Button
          type="submit"
          variant="contained"
          disabled={isSaving}
          startIcon={isSaving ? <CircularProgress color="inherit" size={16} /> : undefined}
          sx={{ width: { xs: '100%', sm: 'auto' }, minWidth: 120 }}
        >
          {isSaving ? 'Saving…' : 'Save'}
        </Button>

        <Button
          variant="outlined"
          onClick={() => {
            setActiveStep(++activeStep);
          }}
          sx={{ width: { xs: '100%', sm: 'auto' } }}
        >
          Next
        </Button>
      </StickyActions>
    </form>
  );
}

export default JobDetail;
